import { Button, Stack, Typography } from '@mui/material';
import AlertCustom from 'components/alert/Alert';
import InfoIcon from '@mui/icons-material/Info';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const AlertLayout = ({ severity, children, Loader, loaderProps, onClose }) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  if (!open) return null;

  return (
    <AlertCustom
      severity={severity}
      iconMapping={{
        info: <InfoIcon style={{ color: '#151F57' }} />,
        warning: <InfoIcon style={{ color: '#FFBE2D' }} />,
      }}
      sx={{
        '.MuiAlert-message': { flex: 1 },
        ' .MuiAlert-icon': { alignItems: 'center' },
      }}
    >
      <Stack direction="row" justifyContent="space-between" flex={1} sx={{ overflow: 'hidden' }}>
        <Stack direction={'row'} flex={1}>
          {children}
          <Button
            sx={{ minWidth: '20px', ml: 2, justifySelf: 'end', textDecoration: 'none !important' }}
            onClick={handleClose}
          >
            X
          </Button>
        </Stack>
        {Loader && <Loader {...loaderProps} />}
      </Stack>
    </AlertCustom>
  );
};

const UpdateBanner = ({ visible, onReload, onDismiss }) => {
  const { t } = useTranslation();

  if (!visible) return null;

  const handleOnClose = () => {
    onDismiss?.();
  };

  const handleUpdate = () => {
    onReload?.();
  };
  return (
    <AlertLayout severity={'info'} onClose={handleOnClose}>
      <Stack direction={'row'} flex={1} justifyContent={'space-between'} alignItems={'center'} alignContent={'center'}>
        <Stack direction={'row'} spacing={1}>
          <Typography component={'span'} style={{ fontWeight: 'bold' }}>
            {t('widgets.update_banner.title')}
          </Typography>
          <Typography component={'span'} style={{ color: '#7A7B84' }}>
            {t('widgets.update_banner.description')}
          </Typography>
        </Stack>
        <Button variant="contained" onClick={handleUpdate}>
          {t('widgets.update_banner.action.reload')}
        </Button>
      </Stack>
    </AlertLayout>
  );
};

export default UpdateBanner;
